import type { DistributionListMember } from '../../shared';

export type PDLMember = DistributionListMember;

export function areMemberArraysEqual(arrayA: PDLMember[], arrayB: PDLMember[]): boolean {
    if (!arrayA && !arrayB) {
        return true;
    }

    if (!arrayA || !arrayB || arrayA.length !== arrayB.length) {
        return false;
    }

    return arrayA.every(memberA => arrayB.some(memberB => equals(memberA, memberB)));
}

export function contains(member: PDLMember, array: PDLMember[]): boolean {
    return (array || []).some(arrayMember => equals(member, arrayMember));
}

export function equals(memberA: PDLMember, memberB: PDLMember): boolean {
    if (memberA === memberB) {
        return true;
    }

    if (!memberA || !memberB) {
        return false;
    }

    return getId(memberA) === getId(memberB);
}

/**
 * Gets a unique identifier for a pdl member.
 * For non-pdl members we have seen the email address being undefined from looking at production logs.
 * We are not able to reproduce this internally.
 * In these cases we fall back to using the displayName as Id.
 * @param member PDL member
 */
function getId(member: PDLMember): string {
    return member.isPdl
        ? member.emailAddressWrapper.ItemId.Id
        : member.emailAddressWrapper.EmailAddress !== undefined
        ? member.emailAddressWrapper.EmailAddress
        : member.displayName;
}
